"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatten = flatten;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Component2 = _interopRequireDefault(require("./Component"));

var _DOMComponent = _interopRequireDefault(require("./DOMComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Used as a standard grouping component.  If detected, it should keep
 * the array of values it returns, rather than returning the contents.
 * This is overrideable if a Dic component is defined in the parser.
 * @module Div
 */
var Div = /*#__PURE__*/function (_Component) {
  _inherits(Div, _Component);

  var _super = _createSuper(Div);

  function Div() {
    _classCallCheck(this, Div);

    return _super.apply(this, arguments);
  }

  _createClass(Div, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return Div;
}(_Component2["default"]);

_defineProperty(Div, "propTypes", {
  children: _propTypes["default"].arrayOf(_propTypes["default"].any).isRequired
});

function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);
} // Returns a value or default value


var setValue = function setValue(value, defaultValue) {
  if (value === undefined) {
    return defaultValue;
  }

  return value;
}; // Used to filter out invalid rendered items.


var isValidSubValue = function isValidSubValue(value) {
  return value !== undefined && value !== null;
};
/**
 * Doc Flux allows for creating a structure from a React style component system.
 * Given a parser and DOM components, you can generate a DOM and apply transforms
 * for the DOM.  This can virtually be used to render anything from a PDF to a JSON
 * document.
 * To use with JSX, simply import this package into the file and set the jsx
 * with a comment `@jsx DocFlux.createElement`
 * @module DocFlux
 */


var DocFlux = /*#__PURE__*/function () {
  function DocFlux() {
    _classCallCheck(this, DocFlux);
  }

  _createClass(DocFlux, null, [{
    key: "parseProps",
    // Parses the props and applies defaults.  Does not support nesting.
    value: function parseProps(suppliedProps) {
      var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var props = _objectSpread({}, defaultProps);

      Object.keys(suppliedProps).forEach(function (key) {
        props[key] = setValue(suppliedProps[key], defaultProps[key]);
      });
      return props;
    } // Validates the props given the prop types.

  }, {
    key: "validateProps",
    value: function validateProps(props, propTypes, componentName) {
      _propTypes["default"].checkPropTypes(propTypes, props, 'prop', componentName);
    }
    /**
     * Transforms JSX into parsable elements
     * @static
     * @function
     * @param {Component|string} JSXComponent A String DOM name or Component
     * @return {object} The component to render with props
     */

  }, {
    key: "createElement",
    value: function createElement(JSXComponent, props) {
      var propsWithChildren = _objectSpread({}, props);

      for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        children[_key - 2] = arguments[_key];
      }

      if (children) {
        propsWithChildren.children = flatten(children);
      }

      return {
        node: JSXComponent,
        props: propsWithChildren
      };
    }
  }, {
    key: "isDOMNode",
    value: function isDOMNode(component) {
      return typeof component.node === 'string';
    }
  }, {
    key: "isArray",
    value: function isArray(component) {
      return component.constructor === Array;
    }
  }, {
    key: "resolveDOMNode",
    value: function resolveDOMNode(component, parser) {
      var nodeComponent = parser[component.node] || null;

      if (!nodeComponent && component.node === 'div') {
        nodeComponent = Div;
      }

      return {
        node: nodeComponent,
        props: component.props,
        stringNodeName: component.node
      };
    }
  }, {
    key: "renderDOMNode",
    value: function renderDOMNode(component, parser, renderFunc) {
      var domNode = component.node;
      var DomComponent = parser[domNode];

      if (DomComponent) {
        var props = DocFlux.parseProps(component.props, DomComponent.defaultProps);
        DocFlux.validateProps(props, DomComponent.propTypes, DomComponent.name);
        var comp = new DomComponent(props);
        return renderFunc(comp, parser);
      }

      return null;
    }
  }, {
    key: "isComponent",
    value: function isComponent(component) {
      if (!component.node) return false;
      if (typeof component.node.prototype === 'function') return true;
      if (typeof component.node === 'function') return true;
      if (_typeof(component.node.prototype) === 'object') return true;
      return false;
    }
  }, {
    key: "renderComponent",
    value: function renderComponent(component, parser, renderFunc) {
      var ComponentClass = component.node;
      var props = DocFlux.parseProps(component.props, ComponentClass.defaultProps);
      DocFlux.validateProps(props, ComponentClass.propTypes, ComponentClass.name);
      var value;

      if (ComponentClass.prototype && ComponentClass.prototype.render) {
        var initializedComponent = new ComponentClass(props);
        value = renderFunc(initializedComponent.render(), parser);

        if (ComponentClass.transform) {
          return {
            ref: initializedComponent,
            value: value,
            elementName: component.stringNodeName,
            props: props
          };
        }
      } else {
        value = renderFunc(ComponentClass(props), parser);
      }

      return value;
    }
  }, {
    key: "renderComponentArray",
    value: function renderComponentArray(components, parser, renderFunc) {
      var cleanedRender = components.filter(isValidSubValue);
      var renderSubComponents = cleanedRender.map(function (comp) {
        return renderFunc(comp, parser);
      }).filter(isValidSubValue);
      return renderSubComponents;
    }
  }, {
    key: "isDivComponent",
    value: function isDivComponent(component) {
      return component.node === Div;
    }
    /**
     * Generates a DOM
     * @static
     * @function
     * @param {object} component An object generated from `createElement`
     * @param {object} parser An object that contains a map between DOM nodes to DOM components
     * @return {array|object} The DOM (array if parent node is a div)
     */

  }, {
    key: "render",
    value: function render(component, parser) {
      if (!parser) return null;
      var self = DocFlux;
      if (component === undefined || component === null) return null; // console.log('render', component, self.isDOMNode(component));

      if (self.isDOMNode(component) && parser) {
        return self.render(self.resolveDOMNode(component, parser), parser);
      } // Clean arrays and render items.


      if (self.isArray(component)) {
        return self.renderComponentArray(component, parser, self.render);
      } // Render components


      if (self.isComponent(component)) {
        return self.renderComponent(component, parser, self.render);
      }

      return component;
    }
    /**
     * Transforms a DOM into a Doc
     * @static
     * @param {array|object} fluxDOM The DOM returned from `render`
     * @param {object} builder A document builder, could be a class, an object, or even null
     * @return {object} The builder object after transformation.
     */

  }, {
    key: "transform",
    value: function transform(fluxDOM, builder) {
      var docBuilder = builder;

      if (fluxDOM.constructor === Array) {
        fluxDOM.forEach(function (DOM) {
          docBuilder = DocFlux.transform(DOM, docBuilder);
        });
        return docBuilder;
      }

      if (fluxDOM.ref && fluxDOM.ref instanceof _DOMComponent["default"]) {
        return fluxDOM.ref.constructor.transform(fluxDOM, docBuilder);
      }

      return docBuilder;
    }
  }]);

  return DocFlux;
}();

exports["default"] = DocFlux;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux/dist/DocFlux.js
// module id = 7
// module chunks = 0